import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {VapQuestion} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../state/question-flow-session.query';

declare const $: any;

@Component({
    selector: 'app-vaps-location-four',
    templateUrl: './vaps-location-four.component.html',
    styleUrls: ['./vaps-location-four.component.scss'],
    standalone: false
})
export class VapsLocationFourComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: VapQuestion;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();

  vaps = [];
  sessionDetails: any;

  constructor(
    private ref: ChangeDetectorRef,
    private globalQuestionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
    this.sessionDetails = questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answers) {
        this.question.answers_parsed = JSON.parse(this.question?.answers);
      }
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.vaps = [];
      this.getProductDetails();
    }
  }

  ngAfterViewInit(): void {
    this.ref.detectChanges();
  }

  getProductDetails(): void {
    if (this.getVapPrice(this.currentVap)) {
      for (const c of this.collations) {
        const item = {
          description: [],
          detail1: '',
          detail2: '',
          checked: false,
          is_active: false,
          toggle: false,
          show: false,
          price: 0,
          session_item_id: ''
        };
        if (c?.class_id === 14 && c?.entry_type === 'item' && c?.description_1 && c?.product_id === this.productId) {
          item.description = c?.description_1?.split('|');
          item.session_item_id = c?.session_item_id;

          for (const v of this.collation_vaps) {
            if (v?.class_id === 14 && v?.select === 1 && v?.session_item_id === c?.session_item_id && this.currentVap?.product_vaps_id === v?.product_vaps_id) {
              item.detail1 = v?.detail?.substring(0, v?.detail?.indexOf('|'));
              /*item.detail2 = v?.detail?.substring(v?.detail?.indexOf('|') + 1, v?.detail?.length);*/
              item.price = v?.premium ? v?.premium : 0;
              item.checked = true;
              item.is_active = true;
              item.toggle = true;
              item.show = false;

              if (this.question?.answers_parsed?.length) {
                for (const i of this.question?.answers_parsed) {
                  const answer = i?.answer?.split('|');
                  if (answer?.length && answer[0].toString() === v?.session_item_id?.toString()) {
                    item.detail2 = answer[1]?.toString();
                  }
                }
              }

              this.vaps.push(item);
            }
          }

          if (!this.vaps.some(x => x.session_item_id === c?.session_item_id)) {
            item.description = c?.description_1?.split('|');
            item.session_item_id = c?.session_item_id;
            item.show = false;
            this.vaps.push(item);
          }
        }
      }
    } else {
      for (const c of this.collations) {
        const item = {
          description: [],
          detail1: '',
          detail2: '',
          checked: false,
          is_active: false,
          show: false,
          price: 0,
          session_item_id: ''
        };
        if (c?.class_id === 14 && c?.entry_type === 'item' && c?.description_1 && c?.product_id === this.productId) {
          item.description = c?.description_1?.split('|');
          item.session_item_id = c?.session_item_id;
          this.vaps.push(item);
        }
      }
    }
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  calculate(): void {
    for (let i = 0; i < this.vaps?.length; i++) {
      if (this.vaps[i].checked) {
        this.onChange(i, 1);
      }
    }
  }

  checkAddon(index: any): void {
    this.vaps[index].checked = !this.vaps[index].checked;
    this.vaps[index].is_active = !this.vaps[index].is_active;
    this.vaps[index].show = !this.vaps[index].show;
    if (this.vaps[index].checked) {
      this.onChange(index, 0);
    } else {
      this.vaps[index].price = 0;
      this.onChange(index, 0);
    }
  }

  onChange(index: number, action: number): void {
    if (this.vaps[index]?.detail2) {
      if (+this.vaps[index]?.detail2 < 0) {
        this.vaps[index].detail2 = 0;
      }
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vaps[index]?.detail2.toString();
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vaps[index]?.session_item_id, answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vaps[index]?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    if (this.vaps[index].session_item_id === item?.session_item_id && this.vaps[index]?.checked) {
                      this.vaps[index].price = item?.premium;
                    }
                  });
                  this.amountChanged.emit(this.vaps.filter(i => i?.checked));
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.vaps[index].price = 0;
      this.amountChanged.emit(this.vaps);
    }
  }

}
